import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { useRef } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import ReactPlayer from "react-player";
import { useHistory } from "react-router-dom";
import { io } from "socket.io-client";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import useVdieoHandleS3 from "../../../../../../CustomHooks/useVideoHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";
import "./AddSessionTextEditor.css";
import useVideoHandleWithCompress from "../../../../../../CustomHooks/useVideoHandleWithCompress";

export default function AddSession(props) {
  const history = useHistory();

  const [bannerOrVideo, setBannerOrVideo] = useState("0");
  const [loading, setLoading] = useState(false);



  // const [videoData, setVideoData] = useState("");
  // const [videoFile, setVideoFile] = useState("");

  const [starList, setStarList] = useState([]); // for multiple star
  const [convertedContent, setConvertedContent] = useState(null);
  const [instruction, setInstruction] = useState(null);

  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'learningSession/images', delKey);

  // Video File Handle
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'learningSession/videos', videoDelKey);


  const [registerInput, setRegister] = useState({
    title: "",
    description: "",
    video: "",
    type: "",
    star_id: "",
    event_date: "",
    start_time: "",
    end_time: "",
    fee: "",
    assignment: "",
    registration_start_date: "",
    registration_end_date: "",
    participant_number: "",
    error_list: [],
  });

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
    e.persist();
    setRegister({ ...registerInput, [e.target.name]: e.target.value });
  };

  // Fetch Stars Added By Admin
  useEffect(() => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  }, []);

  const handleChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const handleChangeVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo(file[0]);
  };

  const socket = useRef();
  /**
   * socket connection
   */
  const { shoketUrl } = useContext(serverInfo);
  useEffect(() => {
    socket.current = io(shoketUrl);
  }, []);

  const registerSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    var banner_or_video = parseInt(bannerOrVideo);
    const fData = new FormData();
    fData.append("banner_or_video", banner_or_video);
    fData.append("image", fileKey);
    fData.append("video", videoKey);
    fData.append("title", registerInput.title);
    fData.append("star_id", registerInput.star_id);
    fData.append("assignment", registerInput.assignment);
    fData.append(
      "registration_start_date",
      registerInput.registration_start_date
    );
    fData.append("registration_end_date", registerInput.registration_end_date);
    fData.append("event_date", registerInput.event_date);
    fData.append("start_time", registerInput.start_time);
    fData.append("end_time", registerInput.end_time);
    fData.append("fee", registerInput.fee);
    fData.append("participant_number", registerInput.participant_number);
    fData.append("description", convertedContent);
    fData.append("instruction", instruction);
    // fData.append("room_id", room_id);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/learning_session/create`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.push("/superstar-admin/learning-session/pending");

          socket.current.emit("learning_session_approve", {
            id: res.data.learningSessionId,
          });
        } else {
          setRegister({
            ...registerInput,
            error_list: res.data.errors,
          });
        }
      });
    });
  };

  const handleBannerOrVideo = (e) => {
    setBannerOrVideo(e.target.value);
  };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 mb-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Create Learning Session</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  className="p-3"
                  onSubmit={registerSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row">
                    <div className="col-md-12 mx-auto">
                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text">
                          Select Star
                        </label>
                        <div className="col-md-9">
                          <select
                            onChange={handleInput}
                            name="star_id"
                            className="form-control reply-control"
                            value={registerInput.star_id}
                          >
                            <option className="text-black" value="">
                              --- Select Star ---
                            </option>

                            {starList.map((user, index) => (
                              <option className="text-black" value={user.id}>
                                {user.first_name} {user.last_name}
                              </option>
                            ))}
                          </select>
                          <small className="text-danger">
                            {registerInput.error_list?.star_id}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">Title</label>
                        <div className="col-md-9">
                          <input
                            type="text"
                            className="form-control reply-control"
                            placeholder="Enter title"
                            onChange={handleInput}
                            name="title"
                            value={registerInput.title}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.title}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">
                          Select Video Or Banner
                        </label>
                        <div className="col-md-9">
                          <select
                            onChange={handleBannerOrVideo}
                            name="video_or_banner"
                            className="form-control reply-control"
                            value={bannerOrVideo}
                          >
                            <option className="text-black" value="0">
                              Banner
                            </option>
                            <option className="text-black" value="1">
                              Video
                            </option>
                          </select>
                        </div>
                      </div>

                      {bannerOrVideo === "0" && (
                        <div className="form-group row my-3">
                          <label className="col-md-3 label-text ">Banner</label>
                          <div className="col-md-9 file-x-i">
                            {fileUrl ? (
                              <img
                                src={fileUrl}
                                alt="..."
                                className="demo-preview-image img-fluid"
                              />
                            ) : (
                              ""
                            )}

                            <input
                              type="file"
                              accept="image/*"
                              className="form-control reply-control"
                              onChange={(e) => handleChange(e.target.files)}
                              id="image"
                              name="image"
                            />
                            {video && !videoUrl && <MediaUploadProgressBar progress={progress} />}
                            <small className="text-danger">
                              {registerInput.error_list?.image}
                            </small>
                          </div>
                        </div>
                      )}

                      {bannerOrVideo === "1" && (
                        <>
                          <div className="form-group row my-3">
                            <label className="col-md-3 label-text ">Video</label>
                            <div className="col-md-9 file-x-i">
                              {videoUrl ? (
                                <ReactPlayer
                                  url={videoUrl}
                                  controls
                                  playing={false}
                                  volume={1}
                                  width="100%"
                                  height="200px" // style={{ margin: "0 auto" }}
                                />
                              ) : null}
                              <input
                                type="file"
                                accept="video/*"
                                className="form-control reply-control mb-3"
                                onChange={(e) => handleChangeVideo(e.target.files)}
                                id="video"
                                name="video"
                              />
                              {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}

                              <span className="text-danger">{registerInput.error_list?.video}</span>

                            </div>
                          </div>


                        </>
                      )}

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">
                          Description
                        </label>
                        <div className="col-md-9">
                          <CKEditor
                            name="description"
                            data={convertedContent}
                            editor={ClassicEditor}
                            onChange={(event, editor) => {
                              setConvertedContent(editor.getData());
                            }}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.description}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">
                          Instruction
                        </label>
                        <div className="col-md-9">
                          <CKEditor
                            name="description"
                            data={instruction}
                            editor={ClassicEditor}
                            onChange={(event, editor) => {
                              setInstruction(editor.getData());
                            }}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.instruction}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">
                          Event Date
                        </label>
                        <div className="col-md-3">
                          <input
                            type="date"
                            className="form-control reply-control"
                            onChange={handleInput}
                            name="event_date"
                            value={registerInput.event_date}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.event_date}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-3 label-text">
                        <label className="col-md-3 label-text ">Time</label>
                        <div className="col-md-3">
                          <input
                            type="time"
                            className="form-control reply-control"
                            onChange={handleInput}
                            name="start_time"
                            value={registerInput.start_time}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.start_time}
                          </small>
                        </div>
                        To
                        <div className="col-md-3">
                          <input
                            type="time"
                            className="form-control reply-control"
                            onChange={handleInput}
                            name="end_time"
                            value={registerInput.end_time}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.end_time}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-4">
                        <label className="col-md-3 label-text ">
                          Event Type
                        </label>
                        <div className="col-sm-5">
                          <select
                            onChange={handleInput}
                            name="assignment"
                            className="form-control reply-control"
                            value={registerInput.assignment}
                          >
                            <option className="text-black" value="">
                              --- Choose One ---
                            </option>
                            <option className="text-black" value="0">
                              Without Assignment
                            </option>
                            <option className="text-black" value="1">
                              With Assignment
                            </option>
                          </select>
                          <small className="text-danger">
                            {registerInput.error_list?.assignment}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-3 label-text">
                        <label className="col-md-3 label-text ">
                          Registration Date
                        </label>
                        <div className="col-md-3">
                          <input
                            type="date"
                            className="form-control reply-control"
                            onChange={handleInput}
                            name="registration_start_date"
                            value={registerInput.registration_start_date}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.registration_start_date}
                          </small>
                        </div>
                        To
                        <div className="col-md-3">
                          <input
                            type="date"
                            className="form-control reply-control"
                            onChange={handleInput}
                            name="registration_end_date"
                            value={registerInput.registration_end_date}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.registration_end_date}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-3">
                        <label className="col-md-3 label-text ">Fee</label>
                        <div className="col-sm-5">
                          <input
                            type="number"
                            className="form-control reply-control"
                            placeholder="Enter fee $"
                            onChange={handleInput}
                            name="fee"
                            value={registerInput.fee}
                            min={0}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.fee}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-3">
                        <label className="col-md-3 label-text ">
                          Participant Number
                        </label>
                        <div className="col-sm-5">
                          <input
                            type="number"
                            className="form-control reply-control"
                            placeholder="Enter participant number"
                            onChange={handleInput}
                            name="participant_number"
                            value={registerInput.participant_number}
                            min={0}
                          />
                          <small className="text-danger">
                            {registerInput.error_list?.participant_number}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row my-3 mt-5">
                        <label className="col-md-3 mx-auto">
                          {loading ? (
                            <button
                              className="btn btnConfirm w-100 text-dark con-text-bfo"
                              disabled
                            >
                              <i className="fas fa-spinner fa-pulse"></i>
                            </button>
                          ) : (
                            <button
                              className="btn btnConfirm w-100 text-dark con-text-bfo"
                              type="submit"
                            >
                              Save
                            </button>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
